// Width of the left SidebarRail at rest (when collapsed). The expanded
// sidebar width is local to SidebarRail.
export const RAIL_WIDTH = 60;

// Width of the right Agent Canvas tools rail. Narrower than the left
// rail because it only ever holds a vertical column of canvas tool
// buttons — the panel close (X) lives in the panel chrome itself, so
// the rail does not need to budget room for it.
export const CANVAS_RAIL_WIDTH = 48;

// Horizontal gutter applied around a rail when it's in floating rail mode
// (the `mx-[Npx]` margin on the floating rounded-rectangle chrome).
export const PILL_GUTTER = 12;

// Total horizontal space the right rail allocates in floating rail mode (rail +
// both gutters). Panel chrome hairlines use this offset to extend under
// the rail.
export const PILL_RAIL_OFFSET = CANVAS_RAIL_WIDTH + PILL_GUTTER * 2;
